import { Stack } from '@mui/material';
import { useEffect } from 'react';

import _ from 'lodash';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';
import { ApiResultModal } from '../../../../components/modal/ApiResultHandler';
import {
  PrimaryButton,
  PrimaryOutlinedButton,
} from '../../../../components/style/ButtonStyle';
import {
  InspectionTitle,
  ListSubContentText,
} from '../../../../components/style/TextStyle';
import { useAuthAxios } from '../../../../hooks/useAuthAxios';
import { useYupValidationResolver } from '../../../../hooks/useYupValidationResolver';
import { InspectionScoreList } from '../../../../utils/enum';
import { fDate } from '../../../../utils/formatTime';
import { InspectionInputs } from './InspectionInputs';
import { sliceSerialNumber } from '../../../../utils/helper';

export function EditInspectionCard({
  facility,
  setMode,
  getInspections,
  inspectionId,
  getFacilities,
  getFacility,
}: any) {
  const [getInspectionResult] = useAuthAxios(
    {
      method: 'GET',
      url: `/api/v1/inspection/${inspectionId}`,
    },
    { manual: false },
  );
  const inspection = _.get(getInspectionResult, 'response.data');

  const resolver = useYupValidationResolver(
    Yup.object().shape({
      inspectionResult: Yup.array().nullable(),
      inspectionDate: Yup.string().required('필수 입력값입니다.'),
      inspectionNote: Yup.string().max(1000, '최대 1000자입니다.').nullable(),
    }),
  );

  const form = useForm<any>({
    mode: 'onTouched',
    resolver,
    defaultValues: {
      inspectionScore: InspectionScoreList.A,
      inspectionDate: new Date(),
      inspectionNote: '',
      inspectionResult: [],
    },
    shouldUnregister: false,
  });

  const [putInspectionResult, putInspection] = useAuthAxios({
    method: 'PUT',
    url: `/api/v1/inspection/${inspectionId}`,
  });

  const onSubmit = form.handleSubmit(function (values) {
    const payload = {
      facilityId: facility.facilityId,
      inspectionScore: values.inspectionScore,
      inspectionDate: fDate(values.inspectionDate, 'yyyy-MM-dd'),
      inspectionResult: values.inspectionResult,
      inspectionNote: values.inspectionNote,
    };
    putInspection({ data: payload });
  });

  const [getStatusesResult] = useAuthAxios(
    {
      method: 'GET',
      url: '/api/v1/inspectionResultType',
    },
    { manual: false },
  );
  const statuses = _.get(getStatusesResult, 'response.data');

  const statusString = inspection?.inspectionResultTypes;
  const statusArray = _.split(statusString, ',');
  const status = _.keyBy(statuses, 'title');
  const statusIdArray: any = [];
  for (const item of statusArray) {
    if (status[item] && status[item]?.title === item) {
      statusIdArray.push(status[item]?.inspectionResultTypeId);
    }
  }

  const setValue = form.setValue;
  useEffect(() => {
    if (inspection) {
      setValue('inspectionScore', inspection?.inspectionScore);
      setValue('inspectionResult', statusIdArray);
      setValue('inspectionDate', new Date(inspection?.inspectionDate));
      setValue('inspectionNote', inspection?.inspectionNote);
    }
    // eslint-disable-next-line
  }, [inspection, setValue]);

  return (
    <Stack spacing={5}>
      <Stack spacing={0.5} my={5}>
        <InspectionTitle>{facility?.title || '-'}</InspectionTitle>
        <ListSubContentText textAlign="center">
          북구 {sliceSerialNumber(facility?.serialNumber) || '-'}
        </ListSubContentText>
      </Stack>

      <InspectionInputs
        form={form}
        date={form.watch('inspectionDate')}
        setDate={(date: any) => form.setValue('inspectionDate', date)}
      />

      <Stack direction="row" spacing={1} mt={5}>
        <PrimaryButton onClick={onSubmit}>수정하기</PrimaryButton>
        <ApiResultModal
          apiResult={putInspectionResult}
          successTitle="수정됐습니다."
          successCode={200}
          onSuccessClose={() => {
            setMode('INFO');
            getInspections();
            getFacilities();
            getFacility();
          }}
          failTitle="관리자에게 문의해주세요."
          ErrorCodeTable={{
            PAYLOAD_INVALID: { title: '입력값을 확인해주세요' },
          }}
        />
        <PrimaryOutlinedButton
          sx={{ maxWidth: 156 }}
          onClick={() => {
            setMode('INFO');
          }}
        >
          취소
        </PrimaryOutlinedButton>
      </Stack>
    </Stack>
  );
}
